module.exports = __webpack_public_path__ + "static/media/add_edit_order.df31a61b.svg";